import React, { useRef, useEffect, useState } from 'react';
import TextComponent from './TextComponent';
import ImageComponent from './ImageComponent';
import ContainerComponent from './ContainerComponent';
import ButtonComponent from './ButtonComponent';
import LoginForm from './LoginComponent';
import BoardComponent from './BoardComponent';
import ProductDetailComponent from './ProductDetailComponent';
import ProductListComponent from './ProductListComponent';
import ProductSliderComponent from './ProductSliderComponent';
import SignUpComponent from './SignUpComponent';
import MainBannerComponent from './MainBannerComponent';
import RowComponent from './RowComponent';
import ColumnComponent from './ColumnComponent';
import CartComponent from './CartComponent';
import PaymentComponent from './PaymentComponent';
import PaymentSuccess from './PaymentSuccess';
import PaymentFail from './PaymentFail';
import FAQComponent from './FAQComponent';
import OrderHistoryComponent from './OrderHistoryComponent';
import CompanyHistoryComponent from './CompanyHistoryComponent';
import AssetHistoryComponent from './AssetHistoryComponent';
import MembershipSignupComponent from './MembershipSignupComponent';
import BinaryLegsComponent from './BinaryLegsComponent';
import RichEditorComponent from './RichEditorComponent';
import UserProfileComponent from './UserProfileComponent';
import ImageTextComponent from './ImageTextComponent';
import TrendingItemsComponent from './TrendingItemsComponent';
import FixedBgTextComponent from './FixedBgTextComponent';
import ReviewFormComponent from './ReviewFormComponent';
import TabLayoutComponent from './TabLayoutComponent';
import RecommendedUsersComponent from './RecommendedUsersComponent';
import CustomMembershipSignupComponent from './CustomMembershipSignupComponent';
import TempOne from './TempOne';
import TempTwo from './TempTwo';
import { COMPONENT_TYPES } from '../constants';
import { useTranslation } from '../redux/TranslationHelper';
// import './ComponentRenderer.css';

// 미리보기 모드에서 사용할 컴포넌트 렌더러
// Redux에 의존하지 않고 props로 받은 데이터만 사용
function ComponentRendererWithProps({ component, allComponents, pathVariables = {} }) {
  const componentRef = useRef(null);
  const [deviceType, setDeviceType] = useState('pc'); // 기본값은 PC
  const { t } = useTranslation(); // 다국어 지원 훅 사용

  // 디바이스 타입 감지 및 창 크기 변경 감지
  useEffect(() => {
    // 디바이스 타입 계산 함수
    const calculateDeviceType = () => {
      // window 객체가 존재하는지 확인 (SSR 대비)
      if (typeof window !== 'undefined') {
        const isMobile = window.innerWidth <= 990; // 991px부터는 PC로 설정
        return isMobile ? 'mobile' : 'pc'; // 모바일/태블릿은 'mobile'로 통합
      }
      return 'pc'; // 기본값
    };

    // 초기 디바이스 타입 설정
    setDeviceType(calculateDeviceType());

    // 창 크기 변경 이벤트 리스너
    const handleResize = () => {
      setDeviceType(calculateDeviceType());
    };

    // 이벤트 리스너 등록
    window.addEventListener('resize', handleResize);

    // 클린업 함수
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
  }, [component.id, component.type]);
  
  // 디바이스 타입 변경 이벤트 리스너 추가
  useEffect(() => {
    // 디바이스 타입 변경 이벤트 리스너
    const handleDeviceTypeChange = (event) => {
      const { deviceType: newDeviceType } = event.detail;
      if (newDeviceType && newDeviceType !== deviceType) {
        // 디바이스 타입 변경
        setDeviceType(newDeviceType);
      }
    };
    
    // 이벤트 리스너 등록
    window.addEventListener('deviceTypeChanged', handleDeviceTypeChange);
    
    // 클린업 함수
    return () => {
      window.removeEventListener('deviceTypeChanged', handleDeviceTypeChange);
    };
  }, [deviceType]);
  
  if (!component) {
    console.error('컴포넌트 데이터가 없습니다.');
    return <div className="error-component">잘못된 컴포넌트 데이터</div>;
  }
  
  // 이 컴포넌트의 자식 컴포넌트들 찾기
  const childComponents = allComponents.filter(comp => comp.parentId === component.id);
  
  
  // 부모 컴포넌트 찾기
  const parentComponent = component.parentId ? allComponents.find(comp => comp.id === component.parentId) : null;
  
  // 컴포넌트 타입을 정규화하고 확인
  let componentType = component.type;
  if (typeof componentType === 'string') {
    componentType = componentType.toUpperCase();
  }
  
  const isChildOfColumn = parentComponent && 
    (parentComponent.type === COMPONENT_TYPES.COLUMN || 
     (typeof parentComponent.type === 'string' && parentComponent.type.toUpperCase() === 'COLUMN'));
  
  const isChildOfRow = parentComponent && 
    (parentComponent.type === COMPONENT_TYPES.ROW || 
     (typeof parentComponent.type === 'string' && parentComponent.type.toUpperCase() === 'ROW'));
  
  // 오류 객체를 문자열로 변환하는 함수
  const errorToString = (err) => {
    if (!err) return '';
    if (typeof err === 'string') return err;
    if (typeof err === 'object') {
      return err.message || JSON.stringify(err);
    }
    return String(err);
  };

  const renderComponent = () => {
    // 기본 props 설정
    const props = {
      data: component.data || {},
      content: component.content,
      style: component.style || {},
      isPreview: componentType !== COMPONENT_TYPES.ORDER_HISTORY && componentType !== 'ORDER_HISTORY',
      pathVariables: pathVariables
    };
    
    // 디바이스별 props 적용
    let deviceProps = {...props};
    
    // 디바이스별 스타일 적용
    if (component.style?.deviceProperty && component.style.deviceProperty[deviceType]) {
      deviceProps.style = {
        ...deviceProps.style,
        ...component.style.deviceProperty[deviceType]
      };
    }
    
    // 디바이스별 componentProps 적용
    if (component.componentProps?.deviceProperty && component.componentProps.deviceProperty[deviceType]) {
      deviceProps.componentProps = {
        ...deviceProps.componentProps,
        ...component.componentProps.deviceProperty[deviceType]
      };
    }
    
    // 디바이스별 data 적용
    if (component.data?.deviceProperty && component.data.deviceProperty[deviceType]) {
      deviceProps.data = {
        ...deviceProps.data,
        ...component.data.deviceProperty[deviceType]
      };
    }
    
    // 디바이스별 content 적용 (content가 객체인 경우)
    if (component.content?.deviceProperty && component.content.deviceProperty[deviceType]) {
      // content가 문자열이 아닌 객체인 경우
      if (typeof component.content === 'object') {
        deviceProps.content = {
          ...deviceProps.content,
          ...component.content.deviceProperty[deviceType]
        };
      } 
      // content가 문자열인 경우
      else if (typeof component.content.deviceProperty[deviceType] !== 'undefined') {
        deviceProps.content = component.content.deviceProperty[deviceType];
      }
    }

    try {
      switch (componentType) {
        case COMPONENT_TYPES.TEXT:
        case 'TEXT':
          return <TextComponent {...deviceProps} />;
        case COMPONENT_TYPES.IMAGE:
        case 'IMAGE':
          return <ImageComponent 
            src={deviceProps.content?.src || ''} 
            alt={deviceProps.content?.alt || ''} 
            style={deviceProps.style || {}} 
            content={deviceProps.content || {}} 
          />;
        case COMPONENT_TYPES.CONTAINER:
        case 'CONTAINER':
          return (
            <ContainerComponent {...deviceProps}>
              {childComponents.map(child => (
                <ComponentRendererWithProps 
                  key={child.id} 
                  component={child} 
                  allComponents={allComponents}
                  pathVariables={pathVariables}
                />
              ))}
            </ContainerComponent>
          );
        case COMPONENT_TYPES.BUTTON:
        case 'BUTTON':
          return <ButtonComponent {...deviceProps} />;
        case COMPONENT_TYPES.LOGIN:
        case 'LOGIN':
          console.log('[ComponentRendererWithProps] deviceProps.componentProps', deviceProps.componentProps);
          console.log('[ComponentRendererWithProps] deviceProps.data', deviceProps.data);
          console.log('[ComponentRendererWithProps] deviceProps', deviceProps);
          console.log('[ComponentRendererWithProps] component', component);
          return <LoginForm 
            {...deviceProps}
            backgroundType={deviceProps.componentProps?.backgroundType}
            backgroundUrl={deviceProps.componentProps?.backgroundUrl}
            redirectPath={deviceProps.componentProps?.redirectPath}
          />;
        case COMPONENT_TYPES.BOARD:
        case 'BOARD':
          return <BoardComponent {...deviceProps} />;
        case COMPONENT_TYPES.PRODUCT_DETAIL:
        case 'PRODUCT_DETAIL':
          return <ProductDetailComponent componentProps={{ 
            order: "", 
            none: "none", 
            lg: 12,
            productId: pathVariables.id || deviceProps.data.productId || 49,
            showDescriptionTab: deviceProps.componentProps?.showDescriptionTab !== false,
            showReviewsTab: deviceProps.componentProps?.showReviewsTab !== false,
            showSpecificationTab: deviceProps.componentProps?.showSpecificationTab !== false
          }} {...deviceProps} style={{...deviceProps.style, width: "100%", maxWidth: "100%"}} />;
        case COMPONENT_TYPES.PRODUCT_LIST:
        case 'PRODUCT_LIST':
          return <ProductListComponent componentProps={{
            categoryId: pathVariables.categoryId || deviceProps.data.categoryId,
            itemsPerRow: deviceType === 'mobile' ? 1 : (deviceType === 'tablet' ? 2 : 4) // 모바일 1개, 태블릿 2개, PC 4개로 고정
          }} {...deviceProps} />;
        case COMPONENT_TYPES.PRODUCT_SLIDER:
        case 'PRODUCT_SLIDER':
          return (
            <ProductSliderComponent
              key={`product-slider-${component.id}`}
              componentProps={{
                ...deviceProps.content,
                ...deviceProps.componentProps,
                itemsPerSlide: deviceProps.componentProps?.itemsPerSlide || 4,
                autoSlide: deviceProps.componentProps?.autoSlide !== false,
                autoSlideInterval: deviceProps.componentProps?.autoSlideInterval || 2000,
                imageHeight: deviceProps.componentProps?.imageHeight || 250
              }}
              style={{
                ...deviceProps.style,
                width: '100%'
              }}
            />
          );
        case COMPONENT_TYPES.SIGNUP:
        case 'SIGNUP':
          return <SignUpComponent 
            {...deviceProps} 
            varFields={deviceProps.componentProps?.varFields || {
              var01: { show: false, label: "", type: "input", options: [], required: false, content: "" },
              var02: { show: false, label: "", type: "input", options: [], required: false, content: "" },
              var03: { show: false, label: "", type: "input", options: [], required: false, content: "" }
            }}
            showEmail={deviceProps.componentProps?.showEmail !== false}
            showBirthday={deviceProps.componentProps?.showBirthday !== false}
            showAddress={deviceProps.componentProps?.showAddress !== false}
            showCenterCode={deviceProps.componentProps?.showCenterCode !== false}
            centerCodeLabel={deviceProps.componentProps?.centerCodeLabel || '센터 코드'}
          />;
        case COMPONENT_TYPES.MAIN_BANNER:
        case 'MAIN_BANNER':
          return <MainBannerComponent 
            {...deviceProps} 
            mode={deviceProps.componentProps?.mode || 'slider'} 
            componentProps={{
              ...deviceProps.data,
              ...deviceProps.componentProps,
              banners: deviceProps.content?.banners || deviceProps.data?.banners || deviceProps.componentProps?.banners
            }} 
          />;
        case COMPONENT_TYPES.ROW:
        case 'ROW':
          return (
            <RowComponent {...deviceProps}>
              {childComponents.map(child => (
                <ComponentRendererWithProps 
                  key={child.id} 
                  component={child} 
                  allComponents={allComponents}
                  pathVariables={pathVariables}
                />
              ))}
            </RowComponent>
          );
        case COMPONENT_TYPES.COLUMN:
        case 'COLUMN':
          return (
            <ColumnComponent {...deviceProps}>
              {childComponents.map(child => (
                <ComponentRendererWithProps 
                  key={child.id} 
                  component={child} 
                  allComponents={allComponents}
                  pathVariables={pathVariables}
                />
              ))}
            </ColumnComponent>
          );
        case COMPONENT_TYPES.CART:
        case 'CART':
          return <CartComponent componentProps={deviceProps} />;
        case COMPONENT_TYPES.PAYMENT:
        case 'PAYMENT':
          return <PaymentComponent componentProps={deviceProps} />;
        case COMPONENT_TYPES.PAYMENT_SUCCESS:
        case 'PAYMENT_SUCCESS':
          return <PaymentSuccess {...deviceProps} />;
        case COMPONENT_TYPES.PAYMENT_FAIL:
        case 'PAYMENT_FAIL':
          return <PaymentFail {...deviceProps} />;
        case COMPONENT_TYPES.FAQ:
        case 'FAQ':
          return <FAQComponent id={component.id} faqItems={component.faqItems || []} title={component.title || "자주하는질문"} style={deviceProps.style || {}} />;
        case COMPONENT_TYPES.ORDER_HISTORY:
        case 'ORDER_HISTORY':
          return <OrderHistoryComponent {...deviceProps} isPreview={false} />;
        case COMPONENT_TYPES.COMPANY_HISTORY:
        case 'COMPANY_HISTORY':
          return <CompanyHistoryComponent 
            id={component.id}
            title={deviceProps.content?.title || "회사 연혁"}
            subtitle={deviceProps.content?.subtitle || "저희 회사의 성장 과정을 소개합니다"}
            timelineStyle={deviceProps.content?.timelineStyle || "vertical"}
            colorScheme={deviceProps.content?.colorScheme || {
              primary: '#3498db',
              secondary: '#f1c40f',
              background: '#ffffff',
              text: '#333333'
            }}
            animation={deviceProps.content?.animation !== undefined ? deviceProps.content.animation : true}
            historyItems={deviceProps.content?.historyItems}
            imageWidth={deviceProps.content?.imageWidth || deviceProps.content?.imageSize || 150}
            imageHeight={deviceProps.content?.imageHeight || deviceProps.content?.imageSize || 150}
            style={deviceProps.style}
          />;
        case COMPONENT_TYPES.MILEAGE_HISTORY:
        case 'MILEAGE_HISTORY':
        case COMPONENT_TYPES.ASSET_HISTORY:
        case 'ASSET_HISTORY':
          return <AssetHistoryComponent 
            componentProps={{
              className: "mileage-history-wrapper padding-tb-40",
              title: t(deviceProps.componentProps?.title) || t("자산 내역"),
              emptyText: t(deviceProps.componentProps?.emptyText) || t("자산 내역이 없습니다.")
            }} 
            style={deviceProps.style || {}} 
            isPreview={false}
          />;
        case COMPONENT_TYPES.MEMBERSHIP_SIGNUP:
        case 'MEMBERSHIP_SIGNUP':
          return <MembershipSignupComponent {...component} />;
        case 'CUSTOM_MEMBERSHIP_SIGNUP':
          return <CustomMembershipSignupComponent
            id={component.id}
            productId={component.productId}
            title={component.title}
            description={component.description}
            buttonText={component.buttonText}
            completedText={component.completedText}
            showRefundVisualization={component.showRefundVisualization}
            refundLimitPercent={component.refundLimitPercent}
            assetOptions={component.assetOptions}
            minAmount={component.minAmount}
            style={component.style}
            isPreview={component.isPreview}
            componentProps={component.componentProps}
          />;
        case COMPONENT_TYPES.BINARY_LEGS:
        case 'BINARY_LEGS':
          return <BinaryLegsComponent 
            id={component.id} 
            componentProps={{ 
              title: deviceProps.componentProps?.title || "후원 레그",
            }} 
            style={deviceProps.style} 
            isPreview={false} 
          />;
        case COMPONENT_TYPES.RICH_EDITOR:
        case 'RICH_EDITOR':
          return <RichEditorComponent 
            id={component.id}
            componentProps={{
              content: deviceProps.content || '',
              style: deviceProps.style || {},
              isPreview: true
            }}
            style={deviceProps.style || {}}
          />;
        case COMPONENT_TYPES.USER_PROFILE:
        case 'USER_PROFILE':
          return <UserProfileComponent 
              key={component.id} 
              {...deviceProps} 
              pathVariables={pathVariables} 
              varFields={deviceProps.componentProps?.varFields || {
                var01: { show: false, label: "" },
                var02: { show: false, label: "" },
                var03: { show: false, label: "" }
              }}
          />;

        case COMPONENT_TYPES.TEMP_ONE:
        case 'TEMP_ONE':
          return <TempOne {...component} />;

        case COMPONENT_TYPES.TEMP_TWO:
        case 'TEMP_TWO':
          return <TempTwo {...component} isPreview={true} />;

        case COMPONENT_TYPES.IMAGE_TEXT:
        case 'IMAGE_TEXT':
          return <ImageTextComponent 
            id={component.id} 
            style={deviceProps.style || {}}
            componentProps={{
              ...deviceProps.componentProps,
              imageUrl: deviceProps.componentProps?.imageUrl || 'https://via.placeholder.com/400x300',
              imagePosition: deviceProps.componentProps?.imagePosition || 'left'
            }}
            content={deviceProps.content || ''}
            isPreview={true}
            viewMode={deviceType}
          />;
        case COMPONENT_TYPES.TRENDING_ITEMS:
        case 'TRENDING_ITEMS':
          return <TrendingItemsComponent {...deviceProps} isPreview={true} viewMode={deviceType} />;
        case COMPONENT_TYPES.FIXED_BG_TEXT:
        case 'FIXED_BG_TEXT':
          return <FixedBgTextComponent 
            id={component.id} 
            style={deviceProps.style || {}}
            componentProps={{
              ...deviceProps.componentProps,
              bgImageUrl: deviceProps.componentProps?.bgImageUrl || 'https://via.placeholder.com/1920x1080',
              overlayOpacity: deviceProps.componentProps?.overlayOpacity || 0.3
            }}
            content={deviceProps.content || ''}
            isPreview={true}
            viewMode={deviceType}
          />;
        case COMPONENT_TYPES.REVIEW_FORM:
          return <ReviewFormComponent 
            id={component.id}
            style={deviceProps.style || {}}
            componentProps={deviceProps.componentProps || {}}
            isPreview={true}
            viewMode={deviceType}
          />;
        case COMPONENT_TYPES.TAB_LAYOUT:
        case 'TAB_LAYOUT':
          return <TabLayoutComponent {...deviceProps} />;
        case COMPONENT_TYPES.RECOMMENDED_USERS:
        case 'RECOMMENDED_USERS':
          return <RecommendedUsersComponent 
            id={component.id}
            style={deviceProps.style || {}}
            componentProps={deviceProps.componentProps || {}}
            isPreview={true}
            viewMode={deviceType}
          />;
        default:
          return (
            <div className="unknown-component" style={{ 
              padding: '20px', 
              border: '1px dashed #aaa',
              borderRadius: '4px',
              color: '#666',
              backgroundColor: '#f8f8f8',
              textAlign: 'center',
              ...deviceProps.style
            }}>
              알 수 없는 컴포넌트 타입: {componentType}
            </div>
          );
      }
    } catch (error) {
      console.error('컴포넌트 렌더링 중 오류:', error, component);
      // 에러 메시지를 안전하게 문자열로 변환
      const errorMessage = errorToString(error);
      
      return (
        <div className="component-error">
          <p>컴포넌트 렌더링 오류</p>
          <p>{errorMessage}</p>
          <pre>{JSON.stringify(component, null, 2)}</pre>
        </div>
      );
    }
  };

  // 컴포넌트의 클래스 이름 설정 - 미리보기 모드 스타일 적용
  const componentClassName = `component-wrapper preview-mode component-type-${componentType.toLowerCase()}`;
  
  // 자동 높이 사용 여부 확인 (ProductDetailComponent, ProductListComponent 같은 컴포넌트는 자동 높이 사용)
  const useAutoHeight = componentType === COMPONENT_TYPES.PRODUCT_DETAIL || 
                      componentType === COMPONENT_TYPES.PRODUCT_LIST ||
                      componentType === 'PRODUCT_DETAIL' ||
                      componentType === 'PRODUCT_LIST' ||
                      componentType === COMPONENT_TYPES.LOGIN ||
                      componentType === 'LOGIN' ||
                      componentType === COMPONENT_TYPES.USER_PROFILE ||
                      componentType === 'USER_PROFILE' ||
                      componentType === COMPONENT_TYPES.SIGNUP ||
                      componentType === 'SIGNUP' ||
                      componentType === COMPONENT_TYPES.MAIN_BANNER ||
                      componentType === 'MAIN_BANNER' ||
                      componentType === COMPONENT_TYPES.RECOMMENDED_USERS ||
                      componentType === 'RECOMMENDED_USERS' ||
                      componentType === COMPONENT_TYPES.CART ||
                      componentType === 'CART' ||
                      componentType === COMPONENT_TYPES.PAYMENT ||
                      componentType === 'PAYMENT' ||
                      componentType === COMPONENT_TYPES.PAYMENT_SUCCESS ||
                      componentType === 'PAYMENT_SUCCESS' ||
                      componentType === COMPONENT_TYPES.PAYMENT_FAIL ||
                      componentType === 'PAYMENT_FAIL' ||
                      componentType === COMPONENT_TYPES.FAQ ||
                      componentType === 'FAQ' ||
                      componentType === COMPONENT_TYPES.ORDER_HISTORY ||
                      componentType === 'ORDER_HISTORY' ||
                      componentType === COMPONENT_TYPES.COMPANY_HISTORY ||
                      componentType === 'COMPANY_HISTORY' ||
                      componentType === COMPONENT_TYPES.MILEAGE_HISTORY ||
                      componentType === 'MILEAGE_HISTORY' ||
                      componentType === COMPONENT_TYPES.CUSTOM_MEMBERSHIP_SIGNUP ||
                      componentType === 'CUSTOM_MEMBERSHIP_SIGNUP' ||
                      componentType === COMPONENT_TYPES.MEMBERSHIP_SIGNUP ||
                      componentType === 'MEMBERSHIP_SIGNUP' ||
                      componentType === COMPONENT_TYPES.BINARY_LEGS ||
                      componentType === 'BINARY_LEGS' ||
                      componentType === COMPONENT_TYPES.RICH_EDITOR ||
                      componentType === 'RICH_EDITOR' ||
                      componentType === COMPONENT_TYPES.PRODUCT_SLIDER ||
                      componentType === 'PRODUCT_SLIDER' ||
                      componentType === COMPONENT_TYPES.USER_PROFILE ||
                      componentType === 'USER_PROFILE' ||
                      componentType === COMPONENT_TYPES.IMAGE_TEXT ||
                      componentType === 'IMAGE_TEXT' ||
                      componentType === COMPONENT_TYPES.TRENDING_ITEMS ||
                      componentType === COMPONENT_TYPES.FIXED_BG_TEXT ||
                      componentType === 'FIXED_BG_TEXT' ||
                      componentType === COMPONENT_TYPES.BOARD ||
                      componentType === 'BOARD' ||
                      componentType === COMPONENT_TYPES.REVIEW_FORM || 
                      componentType === 'REVIEW_FORM' ||
                      componentType === COMPONENT_TYPES.TAB_LAYOUT ||
                      componentType === 'TAB_LAYOUT';
  
  // IMAGE_TEXT 컴포넌트는 minHeight 제한 없이 콘텐츠에 맞게 자동 조정
  const isImageTextComponent = componentType === COMPONENT_TYPES.IMAGE_TEXT || componentType === 'IMAGE_TEXT';
  
  // 기본 스타일 설정 (컴포넌트 데이터가 불완전한 경우에도 동작)
  const componentStyle = {
    position: 'relative',
    width: component.size?.width || '100%',
    // height: useAutoHeight ? 'auto' : (component.size?.height || 'auto'),
    // minHeight: useAutoHeight ? (isImageTextComponent ? 'unset' : '150px') : undefined,
    height: 'auto',
    // minHeight: '150px',
    boxSizing: 'border-box',
    // marginBottom: '10px'
  };
  
  
  // // 부모 컴포넌트에 따라 위치 설정
  // if (!isChildOfColumn && !isChildOfRow) {
  //   componentStyle.left = component.position?.x || 0;
  //   componentStyle.top = component.position?.y || 0;
  // }
  
  return (
    <div
      className={componentClassName}
      style={componentStyle}
      data-component-id={component.id}
      data-component-type={componentType}
    >
      <div ref={componentRef} className="component-content">
        {renderComponent()}
      </div>
    </div>
  );
}

export default ComponentRendererWithProps; 